import { gql } from '@apollo/client';

export const MODEL_VERSIONS = gql`
  query getAvailableModelVersions(
    $inputEurotaxCode: String
    $inputModelVersion: String
    $inputConstructorCode: String
    $inputPlateNumber: String
    $inputVehicleYears: [Int!]
    $inputBrandNames: [String!]
    $inputModelNames: [String!]
  ) {
    getAvailableModelVersions(
      inputModelVersion: $inputModelVersion
      inputBrandNames: $inputBrandNames
      inputModelNames: $inputModelNames
      inputEurotaxCode: $inputEurotaxCode
      inputConstructorCode: $inputConstructorCode
      inputPlateNumber: $inputPlateNumber
      inputVehicleYears: $inputVehicleYears
    ) {
      modelVersions {
        eurotaxCode
        label
      }
    }
  }
`;
